import { useEffect } from 'react'
import './App.css'
import { Routes, Route, useLocation } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import Home from './pages/Home/Home'
import Service from './pages/Service/Service'
import SubService from './pages/SubService/SubService'
import CarClassification from './pages/CarClassification/CarClassification'
import QualityControl from './pages/QualityControl/QualityControl'
import OurWorks from './pages/OurWorks/OurWorks'
import Contacts from './pages/Contacts/Contacts'
import Header from './components/Header/Header'
import Footer from './components/Footer/Footer'
import AdminApp from './admin/AdminApp'

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1 } },
})

const ScrollToTop = () => {
  const { pathname } = useLocation()
  useEffect(() => {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    window.scrollTo({ top: 0, left: 0, behavior: prefersReducedMotion ? 'auto' : 'smooth' })
  }, [pathname])
  return null
}

function PublicLayout() {
  const location = useLocation()
  return (
    <>
      <ScrollToTop />
      <Header />
      <main className="page-transition" key={location.pathname}>
        <Routes location={location}>
          <Route path="/" element={<Home />} />
          <Route path="/services/:slug" element={<Service />} />
          <Route path="/services/:slug/:subSlug" element={<SubService />} />
          <Route path="/car-classification" element={<CarClassification />} />
          <Route path="/quality-control" element={<QualityControl />} />
          <Route path="/our-works" element={<OurWorks />} />
          <Route path="/contacts" element={<Contacts />} />
        </Routes>
      </main>
      <Footer />
    </>
  )
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Routes>
        <Route path="/admin/*" element={<AdminApp />} />
        <Route path="/*" element={<PublicLayout />} />
      </Routes>
    </QueryClientProvider>
  )
}

export default App
